import { createApp } from '@neos/app'
import { views } from './views'
import { menuItems } from './menuItems'
import images from './images'
import '@neos/design-system/dist/design-system.css'
import '@neos/app/dist/app.css'
import '@neos/ai/dist/ai.css'
import '@neos/rich-text-editor/dist/rich-text-editor.css'

const resources = import.meta.glob<boolean, string, { default: Record<string, unknown> }>('./resources/*.ts')

const themes = import.meta.glob<boolean, string, string | undefined>('./themes/*.css', {
  query: '?inline',
  import: 'default',
})

createApp({
  production: import.meta.env.PROD,
  name: 'TMSAscTracking',
  title: 'TMSAscTracking',
  version: '2.4.0',
  company: 'Groupe Isagri Services',
  languages: ['en', 'fr'],
  importResources: (lang) => resources[`./resources/${lang}.ts`],
  themes: [{ name: 'NeosV1', colorScheme: 'light', animatedButtons: false, buttonsLayoutReverseOrder: false }, { name: 'NeosV2', colorScheme: 'light', animatedButtons: false, buttonsLayoutReverseOrder: false }, { name: 'NeosV3', colorScheme: 'light', animatedButtons: true, buttonsLayoutReverseOrder: false }, { name: 'NeosV3Dark', colorScheme: 'dark', animatedButtons: true, buttonsLayoutReverseOrder: false }, { name: 'TmsAscTracking', colorScheme: 'light', animatedButtons: false, buttonsLayoutReverseOrder: false }],
  importTheme: (theme) => themes[`./themes/${theme}.css`]?.(),
  hotModuleReload: import.meta.hot,
  views,
  menuItems,
  images,
  initializationMethods: [],
  mainUIViewName: 'TmsAscOrderTrackingUI',
  uiDefaultBehavior: {},
})